import { Component, OnInit, OnDestroy, ViewChild, ViewEncapsulation } from '@angular/core';
import { AppComponent } from 'src/app/app.component';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { DateTime } from 'luxon';
import { UtilsService } from 'src/app/services/utils.service';
import { RecaptchaComponent } from 'ng-recaptcha';
import { AppSettings } from 'src/app/app.settings';
import { CrossCpService } from 'src/app/cross-utils/services/cross-cp.service';
import { crossMsg, CrossService, drOption, MyReq } from '@robisoft/cross-library';
import { GetHotelInfoReq, GetHotelInfoResp, GetPacchettiReq } from 'src/app/models/Pacchetti';
import { GolfService } from 'src/app/services/golf.service';
import { Repository } from 'src/app/models/Repository';
import { GalleryHotelComponent } from 'src/app/dialogs/gallery-hotel/gallery-hotel.component';
import { PrivacyComponent } from 'src/app/cross-utils/privacy/privacy.component';
import { SendFormReq } from 'src/app/models/SendForm';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-ricerca-pacchetti-golf',
  templateUrl: './ricerca-pacchetti-golf.component.html',
  styleUrls: ['./ricerca-pacchetti-golf.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})

export class RicercaPacchettiGolfComponent implements OnInit, OnDestroy {

  pacchetti: Repository[];
  hotels: GetHotelInfoResp[];

  regioni: string[];
  currRegione: string;

  minDate: DateTime;
  waitingOrari: boolean;
  panelOpenState: boolean;

  prenotaNome: string;
  prenotaEmail: string;
  prenotaMobile: string;
  prenotaTesto: string;
  privacy: boolean;
  errorMessage: string;
  submit: boolean;

  captcha: string;
  @ViewChild('recaptcha') captchaElem: RecaptchaComponent;
  public partner: string;
  sub: Subscription;
  firstRun: boolean;

  constructor(public app: AppComponent,
    private golf: GolfService,
    public sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private cpService: CrossCpService,
    public crossService: CrossService,
    public utils: UtilsService) {
    this.panelOpenState = false;
    this.prenotaNome = '';
    this.prenotaEmail = '';
    this.prenotaMobile = '';
    this.prenotaTesto = '';
    this.errorMessage = '';
    this.captcha = '';
    this.submit = false;
    this.privacy = false;
    this.sub = new Subscription();
    this.firstRun = false;
    this.regioni = [];
    this.currRegione = '';
  }

  async ngOnInit() {
    this.sub = this.app.initialized.subscribe(async (init) => {
      if (init && !this.firstRun) {
        await this.refreshPacchetti();
      }
    });
  }

  async refreshPacchetti(regione: string = ''): Promise<void> {
    if (!this.app.store)
      return;
    this.firstRun = true;

    let req = new GetPacchettiReq();
    req.store = 'admin';
    req.region = regione;

    this.pacchetti = [];
    this.hotels = [];

    const resp = await this.golf.GetPacchetti(req);
    if (resp && resp.pacchetti && resp.pacchetti.length > 0) {
      this.pacchetti = [];
      resp.pacchetti.forEach(pac => {
        this.pacchetti.push(pac as Repository);
        /* compilo la select con la scelta delle regioni */
        if (!regione && pac.T[0] && this.regioni.find(reg => reg.toLowerCase() === pac.T[0].toLocaleLowerCase()) == undefined)
          this.regioni.push(pac.T[0]);
      });
      this.regioni.sort();
      this.pacchetti.forEach((pac) => {
        /* if (pac.D[0])
          pac.D[0] = DateTime.fromISO(pac.D[0].toISO());
        if (pac.D[1])
          pac.D[1] = DateTime.fromISO(pac.D[1].toISO()); */

        this.hotels.push(new GetHotelInfoResp());
      });

    }
  }

  ngOnDestroy() {
  }

  async selezionaRegione() {
    this.refreshPacchetti(this.currRegione);
  }

  public titolo(pacchetto: Repository): string {
    return this.crossService.getLangString(pacchetto.Title, this.app.currlang.toLowerCase());
  }

  public descrizione(pacchetto: Repository): string {
    return this.crossService.getLangString(pacchetto.Description, this.app.currlang.toLowerCase());
  }

  public sanitizeImage(image: string) {
    const url = AppSettings.URL;
    if (image.startsWith('img/'))
      return this.sanitizer.bypassSecurityTrustStyle(`url('${url}/${image}')`);
    else
      return this.sanitizer.bypassSecurityTrustStyle(`url('${url}/img/${this.app.store}/${image}')`);
  }

  public sanitizeUrl(image: string) {
    if (image.startsWith('img/'))
      return this.sanitizer.bypassSecurityTrustUrl(AppSettings.URL + '/' + image);
    else
      return this.sanitizer.bypassSecurityTrustUrl(AppSettings.URL + '/img/' + this.app.store + '/' + image);
  }

  getClass(index: number) {
    return 'element' + index;
  }

  formatCurrency(price: number): string {
    let ret = price.toFixed(2);
    if (this.app.currlang.toLowerCase() === 'it' || this.app.currlang.toLowerCase() === 'de') {
      ret = ret.replace(',', '#').replace('.', ',').replace('#', '.');
    }
    return ret;
  }

  async getMoreInfo(pacchetto: Repository, index: number): Promise<void> {
    if (pacchetto.isSelected) {
      pacchetto.isSelected = false;
    } else {
      this.pacchetti.forEach(pac => {
        pac.isSelected = false;
      });

      this.privacy = false;
      this.errorMessage = '';
      this.captcha = '';
      if (this.captchaElem)
        this.captchaElem.reset();

      let req = new GetHotelInfoReq();
      req.store = 'admin';
      req.hotelId = pacchetto.StoreID;

      this.hotels[index] = await this.golf.GetHotelInfo(req);

      pacchetto.isSelected = true;
    }

  }

  getStyle(isSelected: boolean) {
    if (isSelected) {
      return { 'height': 'auto' };
    } else {
      return { 'height': '0' };
    }
  }

  checkValidity(pacchetto: Repository): boolean {
    if (pacchetto.D[0] && pacchetto.D[1])
      return pacchetto.D[0].startOf('day').toMillis() <= DateTime.local().startOf('day').toMillis() && pacchetto.D[1].startOf('day').toMillis() >= DateTime.local().startOf('day').toMillis();
    else if (pacchetto.D[0] && !pacchetto.D[1])
      return pacchetto.D[0].startOf('day').toMillis() <= DateTime.local().startOf('day').toMillis();
    else if (pacchetto.D[1] && !pacchetto.D[0])
      return pacchetto.D[1].startOf('day').toMillis() >= DateTime.local().startOf('day').toMillis();
    else
      return true;
  }

  checkForm() {
    if (!this.submit) // se non ho ancora premuto 'invia' allora non controllo
      return '';

    const emailExp: RegExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

    if (this.prenotaNome === '')
      this.errorMessage = 'errors.insert-name';
    else if (this.prenotaEmail === '')
      this.errorMessage = 'errors.insert-email';
    else if (!emailExp.test(this.prenotaEmail))
      this.errorMessage = 'errors.invalid-email';
    /* else if (this.prenotaMobile === '')
      this.errorMessage = 'errors.insert-mobile'; */
    else if (this.prenotaTesto === '')
      this.errorMessage = 'errors.insert-text';
    else if (this.privacy === false)
      this.errorMessage = 'errors.accept-conditions';
    else if (this.captcha === '')
      this.errorMessage = 'errors.check-recaptcha';
    else
      this.errorMessage = '';

    return this.errorMessage;
  }

  resolved(captchaResponse: string) {
    this.captcha = captchaResponse;
    this.checkForm();
  }

  async inviaHotel(store: string, pacchetto: string) {
    this.submit = true;
    this.errorMessage = '';
    this.checkForm();

    if (this.errorMessage === '') {
      const req = new SendFormReq();
      req.store = store; // invia l'hotel selezionato!
      req.responseCaptcha = this.captcha;
      req.emailModel = 'pacchetti-golf';
      req.emailModel2 = 'richiesta-inoltrata';
      req.lang = 'it';
      req.fields = [];
      req.fields.push(new drOption(pacchetto, 'Pacchetto'));
      req.fields.push(new drOption(this.prenotaNome, 'Nome Cognome'));
      req.fields.push(new drOption(this.prenotaEmail, 'Email'));
      req.fields.push(new drOption(this.prenotaMobile, 'Cellulare'));
      req.fields.push(new drOption(this.prenotaTesto, 'Messaggio'));
      const resp = await this.cpService.sendForm(AppSettings.API_ENDPOINT, req);
      if (resp.error === '') {
        this.prenotaNome = '';
        this.prenotaEmail = '';
        this.prenotaMobile = '';
        this.prenotaTesto = '';
        this.privacy = false;
        this.errorMessage = '';
        this.captcha = '';
        this.submit = false;
        this.captchaElem.reset();
        this.app.onMessage.emit(new crossMsg('showToastMessage', {
          message: 'Messaggio inviato con successo',  // this.translate.instant('messages.message-send-correctly')
        }));
      }
    }
  }

  async invia() {
    this.submit = true;
    this.errorMessage = '';
    this.checkForm();

    if (this.errorMessage === '') {
      const req = new SendFormReq();
      req.store = this.app.store;
      req.responseCaptcha = this.captcha;
      req.emailModel = 'pacchetti-golf';
      req.emailModel2 = 'richiesta-inoltrata';
      req.lang = 'it';
      req.fields = [];
      req.fields.push(new drOption(this.prenotaNome, 'Nome Cognome'));
      req.fields.push(new drOption(this.prenotaEmail, 'Email'));
      req.fields.push(new drOption(this.prenotaMobile, 'Cellulare'));
      req.fields.push(new drOption(this.prenotaTesto, 'Messaggio'));
      const resp = await this.cpService.sendForm(AppSettings.API_ENDPOINT, req);
      if (resp.error === '') {
        this.prenotaNome = '';
        this.prenotaEmail = '';
        this.prenotaMobile = '';
        this.prenotaTesto = '';
        this.privacy = false;
        this.errorMessage = '';
        this.captcha = '';
        this.submit = false;
        this.captchaElem.reset();
        this.app.onMessage.emit(new crossMsg('showToastMessage', {
          message: 'Messaggio inviato con successo',  // this.translate.instant('messages.message-send-correctly')
        }));
      }

    }
  }

  async openGalleryDialog(hotelGallery: GetHotelInfoResp) {
    const dialogRef = this.dialog.open(GalleryHotelComponent, {
      data: hotelGallery,   /* ticket.ShopQta */
      width: '95%',
      height: '98vh'
    });
    dialogRef.afterClosed().subscribe((goto) => {
      if (goto) {
        this.app.onMessage.emit(new crossMsg('gotoCart', {
          store: this.app.store,
        })
        );
        //this.router.navigate(['/carrello'], { queryParams: { store: this.app.store } });
      }
    });
  }

  openUrl(url: string) {
    let link = '';
    if (!url) {
      url = 'https://opengolf.it/it/privacy-policy?header=no';
    }
    if (url.startsWith('http'))
      link = url;
    else
      link = AppSettings.URL + '/img/' + this.app.store + '/' + url;

    const dialogRef = this.dialog.open(PrivacyComponent, {
      data: {
        privacyUrl: link
      },
      panelClass: 'full-screen'
    });

  }

}
